// extracted by mini-css-extract-plugin
export default {"icon":"oWGQvX_ihWJiutOr7qJf"};